import { Box, Button, TextField, SelectChangeEvent, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { FilterList, FilterListOff } from "@mui/icons-material";
import { useState } from "react";

import { CouponFiltersStyle } from "./style.ts";

interface IDefaultValues {
    search: string;
    status: "ACTIVE" | "DE_ACTIVE" | "REVOKED" | "MAXED_OUT" | null;
    amountType: "FIXED" | "PERCENTAGE" | null;
    appliedTo: "ALL" | "FIRST_SUBSCRIPTION" | null;
}

export const defaultValues: IDefaultValues = {
    search: "",
    status: null,
    amountType: null,
    appliedTo: null,
};

const localFilters = localStorage.getItem("CouponFilters");
const prevFilter = localFilters ? JSON.parse(localFilters) : "";

export default function CouponFilters({ onApply }: { onApply: (data: typeof defaultValues) => void }) {
    const [fields, setFields] = useState<IDefaultValues>(prevFilter || defaultValues);
    const [filterActivated, setFilterActivated] = useState<boolean>(false);

    const handleApply = () => onApply && onApply(fields);
    const toggleFilters = () => setFilterActivated((prev) => !prev);
    const handleReset = () => {
        setFields(defaultValues);
        localStorage.setItem("CouponFilters", JSON.stringify(defaultValues));
        if (onApply) onApply(defaultValues);
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent) => {
        const name = event.target.name;
        const value = event.target.value;

        setFields((prev) => {
            const filterData = {
                ...prev,
                [name]: value,
            };

            localStorage.setItem("CouponFilters", JSON.stringify(filterData));

            return filterData;
        });
    };

    return (
        <CouponFiltersStyle>
            <Box className="filter-wrapper">
                {filterActivated && (
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item lg={3} md={4} xs={12}>
                            <TextField
                                fullWidth
                                className="input field"
                                label="Search"
                                name="search"
                                placeholder="Enter some text"
                                size="small"
                                value={fields.search}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item lg={2} md={4} xs={12}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="status-label">Status</InputLabel>
                                <Select
                                    id="status"
                                    label="Status"
                                    labelId="status-label"
                                    name="status"
                                    value={String(fields.status)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}>All</MenuItem>
                                    <MenuItem value="ACTIVE">Active</MenuItem>
                                    <MenuItem value="DE_ACTIVE">Deactivated</MenuItem>
                                    <MenuItem value="REVOKED">Revoked</MenuItem>
                                    <MenuItem value="MAXED_OUT">Maxed Out</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item lg={2} md={4} xs={12}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="amountType-label">Amount Type</InputLabel>
                                <Select
                                    id="amountType"
                                    label="Amount Type"
                                    labelId="amountType-label"
                                    name="amountType"
                                    value={String(fields.amountType)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}>All</MenuItem>
                                    <MenuItem value="FIXED">Fixed</MenuItem>
                                    <MenuItem value="PERCENTAGE">Percentage</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item lg={2} md={4} xs={12}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="appliedTo-label">Applied To</InputLabel>
                                <Select
                                    id="appliedTo"
                                    label="Applied To"
                                    labelId="appliedTo-label"
                                    name="appliedTo"
                                    value={String(fields.appliedTo)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}>All</MenuItem>
                                    <MenuItem value="ALL">All</MenuItem>
                                    <MenuItem value="FIRST_SUBSCRIPTION">First Subscription</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item lg={3} xs={12}>
                            <Box className="actions">
                                <Button className="action-btn" variant="contained" onClick={handleApply}>
                                    Apply
                                </Button>
                                <Button className="action-btn" variant="contained" onClick={handleReset}>
                                    Reset
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Box>
            <Button
                className="filter-btn"
                startIcon={filterActivated ? <FilterListOff /> : <FilterList />}
                variant="contained"
                onClick={toggleFilters}
            >
                Filters
            </Button>
        </CouponFiltersStyle>
    );
}
